nunjucks.configure('views', {
    autoescape: true
});

var app = app || {};


// FIXME: remove this global variable.
var hasErrors = false;

// This is a hack for fullcalendar.js, which uses an undocumented jQuery method.
// This method was removed in jQuery 1.8
$.curCSS = $.css;

function fixLegends() {
	if ($('.msie8').length || $('.msie7').length || $('.firefox3-6').length || $('.firefox3-5').length) {
		$('.legend').each(function(index) {
			var classes = $(this).attr('class');
			$(this).replaceWith($('<div class="'+ classes +'">'+ this.innerHTML +'</div>'));
		});
		if (typeof domObject !== 'undefined') {
			var col1 = $('#curriculog-fields-column-content');
			var col2 = $('#curriculog-steps-column-content');
			domObject.verticalStretchForm(col1, col2);
		}
	}
}

function blockBrowser() {
	if ($('.msie6').length || $('.msie7').length || $('.firefox3-6').length || $('.firefox3-5').length) {
		alert('This browser is not supported. Please upgrade your browser.');
	}
}

/**
 * Convert an object to a Window.open feature string.
 * Fill in missing values with defaults.
 */
function windowFeatures(obj) {
	var key, value, str = [];
	for (key in obj) {
		value = obj[key];
		// convert true/false values to yes/no
		if (value === true) {
			value = 'yes';
		} else if (value === false) {
			value = 'no';
		}
		str.push(key + '=' + value);
	}
	return str.join(',');
}

/**
 * An improved popWindow function. Pass in window features as an object.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.open
 * @param  {String} url      the url of the new window
 * @param  {String} title    the title of the new window
 * @param  {Object} features an object of features that will be converted into
 *                           a feature string.
 * @return {Window}          Returns the newly created Window.
 */
function popWindow(url, title, featuresObj) {
	featuresObj = featuresObj || {};
	var defaults = {
		toolbar: false,
		location: false,
		directories: false,
		status: false,
		menubar: false,
		scrollbars: true,
		resizable: true,
		copyhistory: false,
		width: 800,
		height: 500
	};
	var features = _.defaults(featuresObj, defaults);

	// Generate the 'top' and 'left' keys if they aren't defined.
	if (!features.left && !features.top) {
		features.left = ($(window).width() / 2) - (features.width / 2);
		features.top = ($(window).height() / 2) - (features.height / 2);
	}

	var featureString = windowFeatures(features);
	return window.open(url, title, featureString);
}

/**
 * The original popWindow function. It still pops a fine window.
 */
function popWindowClassic(pageURL, w, h) {
	var left = ($(window).width() / 2) - (w / 2);
	var top = ($(window).height() / 2) - (h / 2);
	var targetWin = window.open(pageURL,'popup', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no,width='+w+', height='+h+', top='+top+', left='+left);
}

/**
 * Set a flash message and then redirect or reload in the callback function.
 * The message will be displayed as a growl when the page reloads.
 * options:
 *    title: the title of the growl message
 *    text: the body of the growl message
 *    callback: a callback to execute after the ajax finishes.
 *				Typically, a change to window.location.href.
 */
function setFlashMessage(options) {
	return $.ajax({
		type: 'PUT',
		url: '/flashMessage',
		data: {
			title: options.title,
			text: options.text
		},
		success: options.callback || function(){}
	});
}

/**
 * Prevent subsequent calls to an ajax function from being executed
 * while the ajax is in progress.
 *
 * @param  {Function} fn -- This function must return a jQuery jqXHR
 * object (the results of $ajax()) or a jQuery.Deffered object.
 * See: http://api.jquery.com/jQuery.Deferred/
 *      http://api.jquery.com/jQuery.ajax/#jqXHR
 *
 * @return {Function} a function that wraps the given function. Calls to
 * this function will return early until the defferred is resolved.
 * Additionally, it will call event.preventDefault() if the first
 * argument to the given function is an event.
 */
var throttleAjax = function(fn) {
	var xhr, ajaxLoading = false;
	return function () {
		if (ajaxLoading) {
			// if the first argument to this function is an event, then
			// call preventDefault, so that there are no side effects.
			if (arguments[0] && arguments[0] instanceof $.Event) {
				arguments[0].preventDefault();
			}
			return xhr;
		}
		ajaxLoading = true;
		xhr = fn.apply(this, arguments);
		xhr.always(function() { ajaxLoading = false; });
		return xhr;
	};
};

// Moved these functions into util (string.js)
var dasherize = Curriculog.util.dasherize;
var capitalize = Curriculog.util.capitalize;
var escapeUserInput = Curriculog.util.escapeHTML;
var parseQueryString = Curriculog.util.parseQueryString;


function growlError(title, text) {
	$('#growls').notify(
		'create', 'warning-template',
		{title: title, text: text},
		{expires: false}
	);
}

function endsWith(string, suffix) {
    return string.indexOf(suffix, string.length - suffix.length) !== -1;
}

$(document).ready(function() {
	fixLegends();
	blockBrowser();

	// need to wait for mvc bundle to load
	app.supportFormDialog = new Curriculog.SupportFormDialog({});

	/* initialize growls */
	$('#growls').notify();

	// Show a growl error when any ajax return 500.
	$.ajaxSetup({
		error: function(x, e) {
			var title, text;
			if (x.status === 500) {
				response = $.parseJSON(x.responseText);
				if (response.error.match(/You are not authorized to access this resource/)) {
					title = 'Unauthorized';
					text  = 'The proposal status may have changed since you started editing. Please reload this page.';
				} else if (response.error.match(/A communication error occurred between Integration Manager and Curriculog/)) {
					title = 'Integration Manager Is Unavailable';
					text = 'Curriculog is unable to connect to Integration Manager at this time. Some elements of this page will be unavailable until connection is re-established.';
				} else if (response.error.match(/You are not authorized to perform this action/)) {
					title = 'Unauthorized';
					text  = 'You are not authorized to perform this action.';
				} else {
					title = 'An Error Occurred';
					text = 'There was an error with your request. Please try again or contact support.';
				}
				growlError(title, text);
			}
		}
	});

	// Display the flash message if one has been set.
	if (window.flashMessage) {
		$('#growls').notify('create', 'saved-template', {
			title: window.flashMessage.title,
			text: window.flashMessage.text
		},{
			expires: false
		});
	}

	if (!window.console) {
		window.console = {};
		var names = ['log', 'debug', 'info', 'warn', 'error', 'assert', 'dir', 'dirxml',
		'group', 'groupEnd', 'time', 'timeEnd', 'count', 'trace', 'profile', 'profileEnd'];
		var noOp = function(){};
		for (var i = 0; i < names.length; ++i) {
			window.console[names[i]] = noOp;
		}
	}

	var dashboardObject = dashboard();
	var searchObject = search();

	$('body').on('click', '.notifications-next-admin', function(event) {
		event.preventDefault();
		dashboardObject.getNotifications(1,'admin');
	});

	$('body').on('click', '.notifications-previous-admin', function(event) {
		event.preventDefault();
		dashboardObject.getNotifications(-1,'admin');
	});

	$('body').on('click', '.notifications-next', function(event) {
		event.preventDefault();
		dashboardObject.getNotifications(1,'user');
	});

	$('body').on('click', '.notifications-previous', function(event) {
		event.preventDefault();
		dashboardObject.getNotifications(-1,'user');
	});

  //keyboard
  $('body').on('keyup', '.notifications-next-admin', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getNotifications(1,'admin');
    }
	});

	$('body').on('keyup', '.notifications-previous-admin', function(event) {
		event.preventDefault();
    if ( event.which === 13 ) {
        dashboardObject.getNotifications(-1,'admin');
    }
	});

	$('body').on('keyup', '.notifications-next', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getNotifications(1,'user');
    }
	});
	$('body').on('keyup', '.notifications-previous', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getNotifications(-1,'user');
    }
	});


	// refresh upcoming events
	$('body').on('click', '.upcoming-next', function(event) {
		event.preventDefault();
		dashboardObject.getUpcomingEvents(-1,'user');
	});

	$('body').on('click', '.upcoming-previous', function(event) {
		event.preventDefault();
		dashboardObject.getUpcomingEvents(1,'user');
	});

	$('body').on('click', '.upcoming-next-admin', function(event) {
		event.preventDefault();
		dashboardObject.getUpcomingEvents(-1,'admin');
	});

	$('body').on('click', '.upcoming-previous-admin', function(event) {
		event.preventDefault();
		dashboardObject.getUpcomingEvents(1,'admin');
	});

  // refresh upcoming events with keyboard
	$('body').on('keyup', '.upcoming-next', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getUpcomingEvents(-1,'user');
    }
	});

	$('body').on('keyup', '.upcoming-previous', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getUpcomingEvents(1,'user');
    }
	});

	$('body').on('keyup', '.upcoming-next-admin', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getUpcomingEvents(-1,'admin');
    }
	});

	$('body').on('keyup', '.upcoming-previous-admin', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
        dashboardObject.getUpcomingEvents(1,'admin');
    }
	});

	$('#curriculog-dashboard-upcoming-events').on('click', '.upcoming-event', function(event) {
		event.preventDefault();
		$(this).siblings().toggle();
		$(this).toggleClass('active');
		$(this).find('.upcoming-event-show-less, .upcoming-event-show-more').toggleClass('active');
		domObject.verticalStretchList();
	});

  $('#curriculog-dashboard-upcoming-events').on('keyup', '.upcoming-event', function(event) {
		event.preventDefault();
    if ( event.which === 13 ){
      $(this).siblings().toggle();
      $(this).toggleClass('active');
      $(this).find('.upcoming-event-show-less, .upcoming-event-show-more').toggleClass('active');
      domObject.verticalStretchList();
    }
	});

	$('#curriculog-site-login').on('click', '#login', function(event) {
		event.preventDefault();
		event.stopPropagation();

    var redirect_url = $(this).attr('href');

		accessObject.checkCookie(redirect_url);
	});

	$('#curriculog-site-userbox').on('click', '#logout', function(event) {
		event.preventDefault();
		event.stopPropagation();

		accessObject.logOut();
		Backbone.trigger('user:logout');
	});

	$('#curriculog-footer').on('click', '#support', function(event) {
		event.preventDefault();
		event.stopPropagation();

		var SupportDialog = Curriculog.Dialog.extend({
			el: app.supportFormDialog.el,
			buttons: {
				'Submit Support Request': function() {
					// submit the items
					app.supportFormDialog.submitForm(this);
				},
				'Cancel': function() {
					// clear the form and close
					app.supportFormDialog.resetForm();
					this.close();
				}
			}
		});
		new SupportDialog();
	});

	$('#curriculog-site-searchbox').on('click', 'a.next',function(event) {
		event.preventDefault();
		event.stopPropagation();

		if ( $(this).hasClass('active')) {
			var location = ($(this).parents('div.clearfix:eq(0)').attr('id')).match(/result-(.*)/)[1];
			searchObject.searchNext(location);
		}
	});

	$('#curriculog-site-searchbox').on('click', 'a.prev',function(event) {
		event.preventDefault();
		event.stopPropagation();

		if ( $(this).hasClass('active')){
			var location = ($(this).parents('div.clearfix:eq(0)').attr('id')).match(/result-(.*)/)[1];
			searchObject.searchPrev(location);
		}
	});

	$('#curriculog-site-searchbox').on('focusin', '#curriculog-site-search-field', function(event) {
		if ($(this).attr('value') === 'Search') {
			$(this).attr('value', '');
		}
	});

	$('#curriculog-site-searchbox').on('focusout', '#curriculog-site-search-field', function(event) {
		if ($(this).val().length === 0) {
			$(this).val('Search');
		}
	});

	$('#curriculog-site-searchbox').on('click', '.curriculog-site-search-delete', function(event) {
		searchObject.reset();
	});

	$('#curriculog-site-searchbox').on('keydown', '#curriculog-site-search-field',function(event) {
		// event.preventDefault();
		event.stopPropagation();
		searchObject.searchForm(event.which);
	});


	$('#curriculog-toolbar').on('click', '#view-search', function(event) {
		event.preventDefault();
		event.stopPropagation();
		$(this).parent().toggleClass('active');
		$("#curriculog-site-search-field").focus();

		if ($('.curriculog-site-search-results').hasClass('active') ){
			searchObject.overlayToggle();
		}
	});

	$('#curriculog-site-help').on('click', 'a', function(event) {
		event.preventDefault();
		event.stopPropagation();

		// Actions
		var dialog = objDialog.createDOMDialog('help-icons', function(dialog, defaults) {
			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			$(dialog).dialog(defaults);
		});
	});

	$.fn.qtip.defaults = $.extend(true, {}, $.fn.qtip.defaults, {
		content: {
			text: 'Tooltip'
		},
		position: {
			corner: {
				tooltip: 'bottomMiddle',
				target: 'topMiddle'
			}
		},
		effect: { type: 'glow' },
		style: {
			background: '#DDD',
			color: 'black',
			border: {
				width: 3,
				radius: 3,
				color: '#CCC'
			}
		}
	});

	var qSelectors = 'div.admin a.curriculog-widget[title], ' +
		'ul.actions li button[title], ' +
		'div.role-actions a.curriculog-widget[title], ' +
		'#curriculog-types-column-tooltabs button, ' +
		'#curriculog-steps-column-tooltabs button, ' +
		'.step:not(.step-unlaunched) ul.participants li, ' +
		'li.toolbar-section button, ' +
		'#curriculog-dashboard-column a[title], ' +
		'.widget-curriculum button[title], ' +
		'.my-current-decision, ' +
		'.tip';

	$(qSelectors).each(function(){
		$(this).qtip({
			content: {text: false},
			style: {tip: true},
			position: {
				my: 'bottom center',
				at: 'top center',
				target: $(this),
				viewport: $(window)
			}
		});
	});

	$('body').on('mousemove', qSelectors, function() {
		if ($(this).data('qtip') === undefined) {

			$(this).qtip({
				content: {text: false},
				show: {ready: true},
				style: {tip: true},
				position: {
					my: 'bottom center',
					at: 'top center',
					target: $(this),
					viewport: $(window)
				}
			});
		}
	});

	var objDialog = dialog();
	var accessObject = access.getInstance();
	var domObject = dom();
});


// Actions: focus-within css workaround
$('#curriculog-site-userbox-container').on('focus', function(){
  $('#curriculog-site-userbox-container').addClass('focus-within');
});
// prevent focus-within when using mouse
$('#curriculog-site-userbox-container').on('mouseout', function(){
  $('#curriculog-site-userbox-container').blur().removeClass('focus-within');
});
$('#curriculog-site-userbox ul li a, #curriculog-site-userbox-container').on('blur', function(event){
  if ($(event.relatedTarget).parents('#curriculog-site-userbox-container').length === 0 ){
    $('#curriculog-site-userbox-container').removeClass('focus-within');
  }
});


// Toolbar: Hamburger Menu
$('.navigation-wrapper').on('click', '.nav-toggle', function(event) {
  $(this)
    .siblings('#curriculog-user-site-navigation, #curriculog-admin-site-navigation')
    .toggleClass('open');
});
